import { PublicRoutes } from "@/constants/routes";
import { Button, Card, Heading, Metric, Text } from "@/design-system";
import { ClientLogos } from "@/pages/landingPage/components";
import { Link } from "react-router";
import { PROOF_METRICS } from "../constants";

export const ProofSection = () => (
  <section aria-labelledby="resultados-title" className="flex flex-col gap-6">
    {/* Mesmo alinhamento do PageSection; o carrossel de logos abaixo vai de
        ponta a ponta, por isso a section não usa o PageSection inteiro. */}
    <div className="px-4 sm:px-6 lg:px-12">
      <div className="mx-auto flex max-w-6xl flex-col gap-8">
        <div className="flex flex-col gap-3">
          <Heading level={2} id="resultados-title">
            Resultados que a imprensa já contou
          </Heading>
          <Text size="lead" tone="muted" className="max-w-prose">
            Números da Fidexa publicados em 2026 por Pequenas Empresas & Grandes
            Negócios, Baguete, Portal ERP e Novo Varejo.
          </Text>
        </div>

        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {PROOF_METRICS.map(metric => (
            <li key={metric.label} className="flex">
              <Card className="w-full">
                <Metric value={metric.value} label={metric.label} />
              </Card>
            </li>
          ))}
        </ul>

        <div>
          <Button asChild variant="ghost" navigates="internal">
            <Link to={PublicRoutes.NEWSROOM}>Ler as matérias na newsroom</Link>
          </Button>
        </div>
      </div>
    </div>

    <ClientLogos />
  </section>
);
